export * from './QColorPicker_BackgroundForeground.js';
//# sourceMappingURL=index.js.map